module.exports = __webpack_public_path__ + "static/media/swiffer.93a0d4ee.png";